export default (status) => {
  const statusTextColors = {
    completed: 'success',
    failed: 'danger',
    processing: 'warning',
    invalid: 'danger',
    unavailable: 'danger',
    expired: 'danger',
    excluded: 'danger',
    pending: 'primary',
  }
  return statusTextColors[status]
}
